import { useTranslation } from 'react-i18next';
import { prettyDate, prettyFloatMoney } from '@/helpers/utils';
import { DATE_FORMAT_MMM_YYYY } from '@/helpers/common';
import IconTriangle from './icon_triangle.svg';
import s from '../index.module.scss';

export const CustomTooltip = ({ data, hovered }) => {
  const { t } = useTranslation('calculator');
  if (!hovered) return null;

  const { index } = hovered;
  const point = data[index];

  return (
    <div className={s.tooltip}>
      <div className={s.tooltip_content}>
        <div>{prettyDate(point.date, DATE_FORMAT_MMM_YYYY)}</div>
        <div>
          {t('graph.portfolio', { amount: prettyFloatMoney(point.earnings) })}
        </div>
        <div>
          {t('graph.contribution', {
            amount: prettyFloatMoney(point.contributions),
          })}
        </div>
      </div>
      <img
        src={IconTriangle}
        alt="trinagle"
        width={16}
        height={8}
        className={s.tooltip_triangle}
      />
    </div>
  );
};
